import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { IDemographicsForm, DemographicsNote } from '../demographic-form';

@Component({
  selector: 'app-instructor-demographics',
  templateUrl: './instructor-demographics.component.html',
  styleUrls: ['./instructor-demographics.component.less']
})
export class InstructorDemographicsComponent implements OnInit, IDemographicsForm {
  @Input() Busy$: BehaviorSubject<boolean>;
  @Output() saveDataEvent = new EventEmitter<{ Note: DemographicsNote, MailingList: string }>();

  public demographicsForm = this.fb.group({
    schoolName: ['', Validators.required],
    schoolRole: ['', Validators.required],
  });
  public schoolRoles = ['ASCP Admin', 'ASCP Contact', 'ASCP Instructor', 'ASCP Main', 'AHP Contact', 'ANP Contact', 'Cosmo Instructor'];

  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit(): void {
  }

  public SaveDemographics() {
    let noteContent = new DemographicsNote("Instructor Demographics", `School Name: ${this.demographicsForm.value.schoolName}\r\nSchool Role: ${this.demographicsForm.value.schoolRole}`);
    this.saveDataEvent.emit({ Note: noteContent, MailingList: 'Instructor Prospect' });
  }

}
